import React from 'react'
import {Routes, Route, Navigate} from 'react-router'
import {useAuth} from 'react-oidc-context'
import {useIsFinancier, useIsGrantProvider, useIsSuperUser} from '../../_theme/utils/authUtil'
import {
  Dashboard,
  FinancierPagesWrapper,
  Calls,
  Deals,
  Settings,
  Pipeline,
  CandidatesDetailPage,
  CallsDetailsPage,
  FinancierCompanyDetails,
  FinancierPortfolioDetails,
  FinancierServiceProviders,
  FinancierProfile,
  NDAReviewPage,
  LazyComponent,
  InboxPage,
  ThreadDetailPage,
} from './LazyRoutes'
import {CorrespondenceHostProvider} from '../features/correspondence/host/CorrespondenceHostContext'
import {createFinancierHost} from '../features/correspondence/host/financierHost'

const FinancierRoutes = () => {
  const auth = useAuth()
  const financierId = auth?.user?.profile?.financier_id as string | undefined
  const isFinancier = useIsFinancier()
  const isGrantProvider = useIsGrantProvider()
  const isSuperUser = useIsSuperUser()
  const financierHost = React.useMemo(
    () => createFinancierHost(financierId ?? ''),
    [financierId]
  )
  return (
    <Routes>
      <Route
        path='financier/:financierId/*'
        element={
          <LazyComponent>
            <FinancierPagesWrapper />
          </LazyComponent>
        }
      >
        {(isFinancier || isSuperUser) && (
          <Route
            index
            path='pipeline'
            element={
              <LazyComponent>
                <Pipeline />
              </LazyComponent>
            }
          />
        )}
        {(isFinancier || isSuperUser) && (
          <Route
            index
            path='portfolio'
            element={
              <LazyComponent>
                <FinancierPortfolioDetails />
              </LazyComponent>
            }
          />
        )}
        <Route
          index
          path='service-providers'
          element={
            <LazyComponent>
              <FinancierServiceProviders />
            </LazyComponent>
          }
        />
        {isFinancier && (
          <Route
            path='portfolio/:id'
            element={
              <LazyComponent>
                <FinancierCompanyDetails />
              </LazyComponent>
            }
          />
        )}
        {(isGrantProvider || isSuperUser) && (
          <Route
            index
            path='calls'
            element={
              <LazyComponent>
                <Calls />
              </LazyComponent>
            }
          />
        )}
        <Route
          path='dashboard'
          element={
            <LazyComponent>
              <Dashboard />
            </LazyComponent>
          }
        />
        <Route
          path='calls/:callId'
          element={
            <LazyComponent>
              <CallsDetailsPage />
            </LazyComponent>
          }
        />
        <Route
          path='calls/:callId/applications/:stage/:applicationIndex'
          element={
            <LazyComponent>
              <CandidatesDetailPage />
            </LazyComponent>
          }
        />
        <Route
          path='deals'
          element={
            <LazyComponent>
              <Deals />
            </LazyComponent>
          }
        />
        <Route
          path='settings'
          element={
            <LazyComponent>
              <Settings />
            </LazyComponent>
          }
        />
        <Route
          path='profile'
          element={
            <LazyComponent>
              <FinancierProfile />
            </LazyComponent>
          }
        />
        {isFinancier && (
          <Route
            path='nda'
            element={
              <LazyComponent>
                <NDAReviewPage />
              </LazyComponent>
            }
          />
        )}
        <Route
          path='correspondence'
          element={
            <CorrespondenceHostProvider host={financierHost}>
              <LazyComponent>
                <InboxPage />
              </LazyComponent>
            </CorrespondenceHostProvider>
          }
        />
        <Route
          path='correspondence/:threadId'
          element={
            <CorrespondenceHostProvider host={financierHost}>
              <LazyComponent>
                <ThreadDetailPage />
              </LazyComponent>
            </CorrespondenceHostProvider>
          }
        />
      </Route>
      <Route
        path='/'
        element={
          isFinancier || isSuperUser ? (
            <Navigate to={`/financier/${financierId}/pipeline`} />
          ) : (
            <Navigate to={`/financier/${financierId}/calls`} />
          )
        }
      />
      <Route
        path='auth/*'
        element={
          isFinancier || isSuperUser ? (
            <Navigate to={`/financier/${financierId}/pipeline`} />
          ) : (
            <Navigate to={`/financier/${financierId}/calls`} />
          )
        }
      />

      <Route
        path='/'
        element={
          isFinancier || isSuperUser ? (
            <Navigate to={`/financier/${financierId}/portfolio/:id`} />
          ) : (
            <Navigate to={`/financier/${financierId}/calls`} />
          )
        }
      />
      <Route
        path='auth/*'
        element={
          isFinancier || isSuperUser ? (
            <Navigate to={`/financier/${financierId}/portfolio/:id`} />
          ) : (
            <Navigate to={`/financier/${financierId}/calls`} />
          )
        }
      />
    </Routes>
  )
}

export default FinancierRoutes
